import React from 'react';
import styled, { css } from 'styled-components';
import StyledRichText from 'components/StyledRichText';
import { blockPadV, blockPadH, blockW } from 'theme/mixins/padding';
import type { TextBlock as T } from './types';
import Icon from 'components/Icons';
import { IconNames } from 'components/Icons/IconList';
import FormattedText from 'components/FormattedText';
import { Maybe } from '.tina/__generated__/types';
interface Content {
  alignment: string;
  subtextPosition: string;
  ctaSection?: Maybe<boolean> | undefined;
}

const Wrapper = styled.div`
  ${blockPadV({ pt: 'lg', pb: 'sm' })};
  ${blockPadH()};
  background-color: ${({ theme }) => theme.themeColors.bg};
  color: ${({ theme }) => theme.themeColors.fg};
`;

const Container = styled.div`
  ${blockW('lg')};
  position: relative;

  svg,
  img {
    display: none;
  }

  ${({ theme }) => theme.mq.lg`
    svg, img {
      display: block;
      position: absolute;
      right: 0;
      bottom: 0;
    }
  `};
`;

const Content = styled.div<Content>`
  display: flex;
  flex-direction: column;
  text-align: ${props => `${props.alignment}`};
  margin: 0 ${props => (props.alignment === 'left' ? '0' : 'auto')};

  ${({ theme, alignment }) => theme.mq.ltXl`  ${
    alignment === 'center' &&
    css`
      h3 {
        font-size: 2rem;
      }
    `
  }
`};

  ${({ theme, alignment }) => theme.mq.lg`
    max-width: ${alignment === 'center' ? '81' : '70'}%;
  `};

  .rich-text {
    order: ${props => props.subtextPosition};
  }

  ${({ theme, ctaSection }) =>
    ctaSection &&
    css`
      a {
        white-space: nowrap;
      }
      max-width: 80%;
      ${theme.mq.sm`
        max-width: 50%;
      `}
      ${theme.mq.md`
        max-width: 45%;
      `}
      ${theme.mq.lg`
        max-width: 33%;
      `}
    `};
`;

const SubText = styled(FormattedText)``;

const TextBlock: React.FC<T> = ({
  styledRichText,
  alignment,
  subtext,
  subtextPosition,
  watermarkIcon,
  ctaSection
}) => {
  return (
    <Wrapper>
      <Container>
        <Content
          alignment={alignment || 'left'}
          subtextPosition={subtextPosition || '0'}
          ctaSection={ctaSection}
        >
          <StyledRichText pFormat={styledRichText?.pFormat} content={styledRichText?.body} />
          <SubText pFormat={'sansRegular30'}>{subtext}</SubText>
        </Content>
        {watermarkIcon && <Icon name={watermarkIcon as IconNames} />}
      </Container>
    </Wrapper>
  );
};

export default TextBlock;
